export enum EElevation {
    zeroPointThree = 0.3,
    zeroPointFive = 0.5,
    one = 1,
    onePointFive = 1.5,
}
export enum ISEElevation {
    one = 1,
    oneAndHalf = 1.5,
    three = 3,
    fourAndHalf = 4.5,
}
